import axios from 'axios';
import { URL, token } from '../utils/constants';

export class API {

    static auth_API (data) {
        return axios(`${URL}/api/v1/auth/voter`, {
            method: 'POST',
            data,
        });
    }

    static get_voting_API (path) {

        return axios.get(`${URL}/api/v1${path}`, {
            headers: { Authorization: window.sessionStorage.getItem('token') && JSON.parse(window.sessionStorage.getItem('token'))[path] },
        });

    }

    static get_all_candidates (path) {
        return axios.get(`${URL}/api/v1${path}/all-candidates`, {
            headers: { Authorization: window.sessionStorage.getItem('token') && JSON.parse(window.sessionStorage.getItem('token'))[path] },
        });
    }

    static post_candidate_vote (path, candidateId) {
        const arrPath = path.split('/');

        return axios.post(`${URL}/api/v1${path}/candidate/${candidateId}/vote`, {
            votingId: arrPath[arrPath.length-1],
            candidateId,
        }, {
            headers: { Authorization: window.sessionStorage.getItem('token') && JSON.parse(window.sessionStorage.getItem('token'))[path] },
        });
    }

}
